import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { User } from '../models';
import { Inotification } from '../models/notification';
import { UserService, AuthenticationService, DashboardService, SpinnerService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';


@Component({ templateUrl: 'dashboard.component.html'
    , styleUrls:['styles.scss'] 
})
export class DashboardComponent {
    users: User[] = [];
    currentUser: User;
    dealerEnrollmentsCount: any;
    subscriptionCount: any;
    
    dealerEnrollmentsCountColumnDefs = [
        {headerName: 'Source', field: 'SourceName' },
        {headerName: 'Count', field: 'DealersCount' }
    ];
    subscriptionCountColumnDefs = [
        {headerName: 'Client Name', field: 'ClientName' },
        {headerName: 'Count', field: 'DealersCount' }
    ];
    totalNoOfIssuesCountColumnDefs = [
        {headerName: 'Status', field: 'Status' },
        {headerName: 'Count', field: 'Count' }
    ];
   
    subMsg: any = "";
    totalDataProcessed: any;
    rowGroupMetadata: {};
    totalNoOfIssues: any;
    constructor(private userService: UserService,
        private dasboardService: DashboardService,
        private router: Router,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { }

    ngOnInit() {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.spinnerService.start();
        this.getDealersCountBySource();
        this.getDealersCountByClient();
        this.getTotalDataProcessed();
        this.getTotalNoOfIssues();
    }
   
    getDealersCountBySource(){
        this.dasboardService.getDealersCountBySource().pipe(first()).subscribe(dealerEnrollments =>{
            this.dealerEnrollmentsCount = dealerEnrollments;
        })
    }
    getDealersCountByClient(){
        this.dasboardService.getDealersCountByClient().pipe(first()).subscribe(result =>{
            if(result.length != 0){
                this.subscriptionCount = result;
            }
            else{
                this.subMsg = "No recors found";
            }
            this.spinnerService.stop();
        })
    }
    getTotalDataProcessed(){
        this.dasboardService.getTotalDataProcessed().pipe(first()).subscribe(result =>{
            this.totalDataProcessed = result;
            this.updateRowGroupMetaData();
        })
    }
    updateRowGroupMetaData() {
        this.rowGroupMetadata = {};

        if (this.totalDataProcessed) {
            for (let i = 0; i < this.totalDataProcessed.length; i++) {
                let rowData = this.totalDataProcessed[i];
                let SourceName = rowData.SourceName;
                
                if (i == 0) {
                    this.rowGroupMetadata[SourceName] = { index: 0, size: 1 };
                }
                else {
                    let previousRowData = this.totalDataProcessed[i - 1];
                    let previousRowGroup = previousRowData.SourceName;
                    if (SourceName === previousRowGroup)
                        this.rowGroupMetadata[SourceName].size++;
                    else
                        this.rowGroupMetadata[SourceName] = { index: i, size: 1 };
                }
            }
        }
        this.spinnerService.stop();
    }
    getTotalNoOfIssues(){
        this.dasboardService.getTotalNoOfIssues().pipe(first()).subscribe(result =>{
            this.totalNoOfIssues = result;
            this.spinnerService.stop();
        })
    }
    
}







